import React from 'react';
import {Tag} from "antd";
import {codeTables} from '../../codes';

export const CodeTag = ({ code, table, ...props }) => {
  if (!code) {
    code = { name: 'Unknown' };
  } else if (table && typeof code !== 'object') {
    let codeTable = codeTables.get(table);
    code = codeTable.find(record => record.code === code) || { name: code }
  } else if (table) {
    let codeTable = codeTables.get(table);
    code = codeTable.find(record => record.code === code.code) || { name: code }
  } else if (typeof code !== 'object') {
    code = { name: code }
  }
  if (code.color) {
    const colorCode = codeTables.get('colors').find(record => record.code === code.color);
    if (colorCode) code.color = colorCode.name;
  }
  return (
    <Tag
      color={code.color}
      className='code-tag'
      {...props}
    >
      {code.name}
    </Tag>
  );
};




// WEBPACK FOOTER //
// ./src/components/Boilerplate/CodeTag.js